import { NgModule } from '@angular/core';
import { IdbWrapperService } from './idb-wrapper.service';

@NgModule({
  providers: [IdbWrapperService]
})
export class IdbWrapperModule { }
